<header id="master-header">
  <div class="container">

    <div class="row align-items-center">
      <div class="col-12 col-lg-auto text-center py-3 py-lg-0">
        <h1 class="logo font-weight-bold">
          <a routerLink="/logado">Viva Mais Previdência</a>
        </h1>
      </div>
      <div class="col-12 col-lg mt-2 mt-lg-0 pl-0">
        <ul class="list-inline pl-0 font-weight-bold">

          <li class="list-inline-item px-2 py-2 py-lg-0 d-block d-lg-inline-block dropdown">
            <a class="dropdown-toggle" style="cursor: pointer;" data-toggle="dropdown">Financeiro</a>
            <ul class="dropdown-menu py-2" style="min-width: 182px;">
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/financeiro/recebimentos" (click)="closeHeader($event)">Recebimentos</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/financeiro/formas-pagamentos" (click)="closeHeader($event)">Formas de Pagamento</a></li>
            </ul>
          </li>

          <li class="list-inline-item px-2 py-2 py-lg-0 d-block d-lg-inline-block dropdown">
            <a class="dropdown-toggle" style="cursor: pointer;" data-toggle="dropdown">Extratos</a>
            <ul class="dropdown-menu py-2" style="min-width: 162px;">
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/extratos/movimentacoes" (click)="closeHeader($event)">Movimentações</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/extratos/fundos" (click)="closeHeader($event)">Fundos</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/extratos/taxa-adm" (click)="closeHeader($event)">Taxa Administrativa</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/extratos/declaracao-anual" (click)="closeHeader($event)">Declaração Anual</a></li>
            </ul>
          </li>

          <li class="list-inline-item px-2 py-2 py-lg-0 d-block d-lg-inline-block dropdown">
            <a class="dropdown-toggle" style="cursor: pointer;" data-toggle="dropdown">Seguro</a>
            <ul class="dropdown-menu py-2" style="min-width: 220px;">
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/seguro-adesao" (click)="closeHeader($event)">Adesão</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/seguro/acompanhar-solicitacoes" (click)="closeHeader($event)">Solicitações</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a routerLink="/logado/seguro/seguros-contratados" (click)="closeHeader($event)">Seguros Contratados</a></li>
            </ul>
          </li>

          <li class="list-inline-item px-2 py-2 py-lg-0 d-block d-lg-inline-block dropdown">
            <a class="dropdown-toggle" style="cursor: pointer;" data-toggle="dropdown">Simulador</a>
            <ul class="dropdown-menu py-2" style="min-width: 220px;">
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a [href]="simulador_renda_info"  target="_blank">Renda</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a href="https://simulador.fundacoesnet.com.br/simulador-projeto-futuro-viva-mais-previdencia" target="_blank">Projeto Futuro</a></li>
              <li class="px-2 py-1 d-block" style="font-size: 0.95rem;"><a href="https://simulador.fundacoesnet.com.br/simulador-deducao-imposto-renda-previdencia" target="_blank">Incentivo FIscal</a></li>
            </ul>
          </li>

          <li class="list-inline-item px-2 py-2 py-lg-0 d-block d-lg-inline-block"><a routerLink="/logado/atendimento" (click)="closeHeader($event)">Atendimento</a></li>
        </ul>
      </div>
      <div class="col-12 col-lg-auto mt-3 mt-lg-0">
        <ul class="list-inline">

          <li class="list-inline-item">
            <span style="color: #848484; font-weight: bold; margin-right: 6px;" class="d-none d-xl-inline-block">{{nome}}</span>
          </li>

          <li class="list-inline-item d-block d-lg-inline-block mb-4 mb-lg-0">
            <!--
            <a href="https://google.com" target="_blank" class="btn btn-primary btn-podcast mr-1 mr-xl-5 d-block d-lg-inline-block">
              <i class="fas fa-headphones-alt mr-1"></i> Nosso Podcast
            </a>
            -->
          </li>

          <li class="list-inline-item d-block d-lg-inline-block mb-4 mb-lg-0">
            <a class="btn btn-transparent" routerLink="/logado/notificacoes" [queryParams]="{filtroMural: 'S'}">
              <i class="far fa-newspaper"></i>
            </a>
          </li>

          <li class="list-inline-item position-relative">
            <button class="btn btn-transparent" (click)="toggleMenuPop('filesmenu')">
              <i class="fas fa-file-alt"></i>
            </button>
            <div class="menuPop position-absolute" id="filesmenu">
              <div class="boxMenu">
                <div class="title"><h4>Arquivos</h4></div>
                <div class="body">
                  <ul class="list-unstyled list-icons">
                    @for (item of files; track item) {
                      <li class="py-2 text-muted">
                        <a (click)="download(item[0], item); false"	href="">
                          <i class="{{ item[1] }} mr-2"></i>{{ item[2] }}
                        </a>
                      </li>
                    }
                  </ul>
                  <h5 class="mt-4 mb-3">
                    Regime Tributário
                  </h5>
                  <p>{{regimeTrib}}</p>
                  <h5 class="mt-4 mb-3">
                    <a routerLink="/logado/notificacoes" [queryParams]="{codAviTipo: 2}" (click)="toggleMenuPop('filesmenu')" style="color: #02567f;">Siga Seu Plano</a>
                  </h5>
                </div>
              </div>
            </div>
          </li>


          <li class="list-inline-item position-relative">
            <button class="btn btn-transparent" (click)="toggleMenuPop('notifymenu')">
              <span class="dot">{{numAvisos}}</span>
              <i class="fas fa-bell"></i>
            </button>
            <div class="menuPop position-absolute" id="notifymenu">
              <div class="boxMenu">
                <div class="title"><h4>Novos Avisos</h4></div>
                <div class="body">

                  <ul class="list-unstyled list-notify">

                    @for (item of avisos; track item) {
                      <li class="py-2" (click)="openModalAViso(); modalAviso.init(item)" style="word-wrap: break-word;">
                        <a href="" (click)="false" class="title">{{item.TITULO}}</a>
                        <div>{{ (item.DESCRICAO.length>6)? (item.DESCRICAO | slice:0:80)+'..': (item.DESCRICAO) }}</div>
                        <div class="date">{{item.TIM_HAB_INICIO| date:"dd/MM/yyyy HH:mm:ss"}}</div>
                      </li>
                    }

                    @if (avisos.length==0) {
                      <li class="text-center">
                        Nenhum Aviso Novo
                      </li>
                    }

                  </ul>

                </div>
                <div class="footer">
                  <a routerLink="notificacoes" class="seeall" (click)="toggleMenuPop('notifymenu')">
                    Ver Histórico
                  </a>
                </div>
              </div>
            </div>
          </li>

          <li class="list-inline-item position-relative">
            <button class="btn btn-transparent" style="color: #02567f" routerLink="/logado/cadastro" (click)="closeHeader($event)">
              <i class="fas fa-cog"></i>
            </button>
          </li>

          <li class="list-inline-item">
            <a class="btn btn-transparent gray font-weight-bold" href="" (click)="sair();false">
              <span class="d-xl-inline-block">Sair</span>
            </a>
          </li>

        </ul>
      </div>
    </div>

  </div>

</header>

<header id="mobile-header" class="d-inline-block d-lg-none">
  <div class="container">

    <div class="row align-items-center py-2">
      <div class="col-auto">
        <h1 class="logo font-weight-bold">
          <a routerLink="/logado" (click)="closeHeader($event)">Fusan</a>
        </h1>
      </div>
      <div class="col text-right pr-1">
        <button class="btn btn-transparent mt-1" (click)="toggleHeader($event)">
          <span>Menu</span>
          <i class="fas fa-bars ml-2" [ngClass]="toggled ? 'fa-times' : 'fa-bars'"></i>
        </button>
      </div>
    </div>

  </div>
</header>


<app-modal-aviso #modalAviso (onModalClose)="carregarAvisoSemAceite(); listarAvisosNaoLidos()" modalID="modalAvisoHeader"></app-modal-aviso>

<router-outlet></router-outlet>

<div class="p-2 mb-3" style="text-align: center; color: #8B8B8B; font-size: 14px;">
  <div>Plano Setorial Instituído Viva Mais Previdência - CNPB: 2019002574.</div>
  <div>CNPJ: 48.307.709/0001-60</div>
</div>
